export default __webpack_public_path__ + "static/media/edit.02c8cb6b.svg";